<template>
  <CimaConfigPanel
    :features="features"
    :feature-id="featureId"
    :label="label"
    :center="center"
    :saved="saved"
    integration="kibi"
    translation-prefix="feature.kibi"
  />
</template>

<script>
import CimaConfigPanel from "./CimaConfigPanel.vue";

export default {
  components: { CimaConfigPanel },
  props: {
    features: Object,
    featureId: [String, Number],
    label: String,
    center: Object,
    saved: { type: Number, default: 0 },
  },
};
</script>
